import $ from 'jquery';
import Flickity from "flickity-fade";


// Ajout de la popup 'Toutes les couleurs' afin d'afficher toutes les couleurs d'un produit en clonant la première instance des swatches.
// On créé une popup et on insert le clone dedans.
let colorsVariationsClone = $('.swatch-shape-circle').clone(true, true);
let colorVariations = $('.tawcvs-swatches .swatch-shape-circle')
let colorsVariationContainer = $('.tawcvs-swatches');
let div = $("<div class='swatches-popup'><div class='swatches-popup-container'><h2>Les couleurs disponibles:</h2><span class='exit-popup'></span></div></div>");
colorsVariationContainer.after('<a href="#" class="all-colors-links">Toutes les couleurs</a>');
$(".tawcvs-swatches").append(div);
$('.swatches-popup-container').append(colorsVariationsClone);

$('.all-colors-links').on('click', function(e) {
    e.preventDefault();
    $('.swatches-popup').toggleClass('active');
});

$('.exit-popup').on('click', function(e) {
    $('.swatches-popup').removeClass('active');
});

$(document).ready(function() {

    //Evement au click pour cloner les pastilles de couleur. A la selection d'une pastille, l'évènement est dupliqué sur le clone 
    $(document).on("click", '.swatch', function(event) {
        event.preventDefault();
        event.stopPropagation();

        let valueSelected = $(this).attr('data-value');

        // Supprime la classe selected sur tous les éléments puis l'ajoute uniquement au bon élément
        colorsVariationsClone.removeClass('selected');
        colorVariations.removeClass('selected');

        let newSelected = colorsVariationsClone.filter(`[data-value="${valueSelected}"]`);
        let newSelectedColor = colorVariations.filter(`[data-value="${valueSelected}"]`);

        newSelected.addClass('selected');
        newSelectedColor.addClass('selected');

        let slider = new Flickity('.tawcvs-swatches');


        var index = $(this).index() - 2;
        slider.selectCell(index,true);
    });
}, 2000);
